<i18n>
{
    "en": {},
    "ru": {
        "caption": "Список духов",
        "error": "Что-то пошло не так",
        "perfumes": "Ароматы",
        "perfumes_l": "ароматы",
        "perfume_one": "аромат",
        "perfume_few": "аромата",
        "perfume_many": "ароматов",
        "popular": "По популярности",
        "alphabet": "По алфавиту",
        "date": "По дате",
        "rating": "По рейтингу",
        "read_also":"Читайте также",
        "best_articles": "Лучшие статьи",
        "chained_pages": "Интересные подборки",
        "is_liked": "Семейство добавлено в избранное",
        "liked_already": "Семейство уже добавлено в избранное",
        "is_unliked": "Семейство удалено из избранного",
        "placeholder": "Введите название аромата...",
        "description_title": "Описание",
        "tooltip_like": "Сохранить в избранное",
        "tooltip_like_users": "<br><span class=\"tooltip__note\">Понравилось {total}</span>",
        "tooltip_subscribe": "Подписаться на обновления",
        "tooltip_share": "Поделиться",
        "filter": "Фильтр",
        "by_filter": "(по фильтру)"
    }
}
</i18n>
<template>
    <div class="families-detail__page">

        <block-price-panel />

        <div class="families-detail__block">
            <PageBlock :content-visible="isDeviceDesktop">
                <Breadcrumb
                    show-prev-button
                    prev-path-name="Families"
                    :items="breadcrumbs"/>

                <SectionCard
                    v-if="isDeviceDesktop"
                    sidebar="detail">
                    <template
                        #leftbar
                        v-if="isDeviceDesktop">
                        <div class="families-detail__picture-wrapper">
                            <img
                                class="families-detail__picture"
                                data-not-lazy
                                v-lazy-load :data-src="get(family, 'picture.url', getNoImage)"
                                :alt="getName" />
                        </div>

                        <PageBlock
                            :smallTitle="isDeviceDesktop"
                            :title="$t('description_title')">

                            <div
                                class="families-detail__description">
                                <ShowMore :max-rows="40">
                                    <!-- eslint-disable-next-line vue/no-v-html -->
                                    <app-content class="html-content html-content_sidebar" :html="get(family, 'description')" />
                                </ShowMore>
                            </div>
                        </PageBlock>

                        <PageBlock small-title :title="$t('read_also')">
                            <ArticlesList
                                :articles="relatedNews"
                                :date-order="false" />
                        </PageBlock>

                        <PageBlock small-title :title="$t('best_articles')">
                            <div class="families-detail__page-block">
                                <ArticleRowItem
                                    :key="index + article.code"
                                    v-for="(article, index) in relatedArticles"
                                    :data="article"/>
                            </div>
                        </PageBlock>

                        <PageBlock small-title :title="$t('chained_pages')">
                            <div class="families-detail__page-block">
                                <LinkedPagesList :items="relatedPages"/>
                            </div>
                        </PageBlock>
                    </template>

                    <template #rightbar>

                        <div class="families-detail__buttons">
                            <ButtonSquare
                                :icon="heartIcon(liked, true)"
                                class="rightbar__button families-detail__button-like"
                                v-tooltip.top="{
                                    content: likesCountTooltipPhrase, 
                                    offset: 14, 
                                    classes: 'tooltip_center'
                                }"
                                :aria-label="likesCountTooltipPhrase"
                                @click.native="handleLike"/>

                            <ButtonSquare
                                :icon="subscribeIcon(userSubscribed)"
                                class="rightbar__button"
                                :class="{'btn__subscribed_active': userSubscribed}"
                                v-tooltip.top="{content: $t('tooltip_subscribe'), offset: 14}"
                                :aria-label="$t('tooltip_subscribe')"
                                @click.native="handleSubscribe(family)"/>

                            <ButtonSquare
                                class="rightbar__button"
                                icon="icon-share-current"
                                v-tooltip.top="{content: $t('tooltip_share'), offset: 14}"
                                :aria-label="$t('tooltip_share')"
                                @click.native="sharePage(family)"/>
                        </div>

                        <PageBlock
                            small-header
                            class="families-detail__right-block"
                            :heading-tag="'h1'"
                            :title="compositeTitle"
                            :caption-count="perfumesCount | numberFormat"
                            :caption="getPerfumesDeclension(false)" />

                        <PageBlock noMargin content-visible>
                            <AromaBox :aromabox="familyAromabox" />
                        </PageBlock>

                        <PageBlock content-visible>
                            <CatalogList
                                id="catalog"
                                grid
                                :grid-columns="4"
                                :placeholder="$t('placeholder')"
                                :search-loading="queryPending"
                                @search="searchQuery = $event"
                                :query="searchQuery"
                                @change-sort-type="onChangeSortType"
                                @change-sort-order="onChangeSortOrder"
                                @show-filter="filterIsShowed = true"
                                @reset-all="resetAll"
                                :with-pagination="false"
                                :single-button-pagination="parseInt(catalogLastPage) > parseInt(catalogPage)"
                                with-filter
                                with-sort
                                search-full-bordered
                                :filter-disabled="isFilterDisabled"
                                show-sort-and-filter
                                :sort-options="sortOptions"
                                :filters-count="filtersCount"
                                v-model="catalogPage"
                                :page-count="catalogLastPage"
                                :sort-order="sortOrder"
                                :sort-type="sortType"
                                class="families-detail__catalog"
                                :items="catalogItems">

                                <template #item="{ item }" >

                                    <BlockOffer
                                        :brand-name="get(item, 'brand.name')"
                                        :name="get(item, 'name')"
                                        :url="get(item, 'htmlUrl')"
                                        :picture="get(item, 'picture.url')"
                                        :produced-from="get(item, 'produced.from')"
                                        :gender-code="get(item, 'gender.code')"
                                        :rating="get(item, 'ratings.value')"
                                        with-rating
                                        direction-column
                                        :comments-count="get(item, 'comments.total')"
                                        :caption="get(item, 'concentration.name', 0)"/>

                                </template>
                            </CatalogList>

                        </PageBlock>
                    </template>
                </SectionCard>

                <SectionCard v-if="!isDeviceDesktop" :loaded="loaded">
                    <div class="families-detail__rightbar"
                        slot="rightbar">
                        <ButtonSquare
                            :icon="heartIcon(liked, true)"
                            class="rightbar__button noses-detail__button-like"
                            aria-label="like"
                            @click.native="handleLike"/>

                        <ButtonSquare
                            :icon="subscribeIcon(userSubscribed)"
                            class="rightbar__button"
                            :class="{'btn__subscribed_active': userSubscribed}"
                            aria-label="subscribe"
                            @click.native="handleSubscribe(family)"/>

                        <ButtonSquare
                            class="rightbar__button"
                            icon="icon-share-current"
                            aria-label="share"
                            @click.native="sharePage(family)"/>

                    </div>
                    <template #main>
                        <div class="families-detail__content">
                            <div class="families-detail__picture-wrapper">
                                <img
                                    class="families-detail__picture"
                                    data-not-lazy
                                    v-lazy-load :data-src="get(family, 'picture.url', getNoImage)"
                                    :alt="getName" />
                            </div>
                            <PageBlock
                                :title="compositeTitle"
                                :heading-tag="'h1'"
                                :caption-count="totalItems | numberFormat"
                                :caption="$options.filters.numberDeclension(totalItems, $t('declensions.perfumes'), false)"
                                small-header
                                no-margin
                                class="families-detail__title-name">
                                <template #description>
                                    <div class="families-detail__description">
                                        <!-- eslint-disable-next-line vue/no-v-html -->
                                        <app-content class="html-content html-content_sidebar" :html="get(family, 'description')" />
                                    </div>
                                </template>
                            </PageBlock>
                        </div>
                    </template>
                </SectionCard>
            </PageBlock>

            <PageBlock v-if="!isDeviceDesktop">
                <AromaBox :aromabox="familyAromabox" />
            </PageBlock>

            <PageBlock
                v-if="!isDeviceDesktop"
                :title="$t('perfumes')"
                :counter="getPerfumesDeclension(true)">

                <CatalogList
                    id="catalog"
                    :placeholder="$t('placeholder')"
                    :search-loading="queryPending"
                    @search="searchQuery = $event"
                    :query="searchQuery"
                    @change-sort-type="onChangeSortType"
                    :filters-count="filtersCount"
                    @change-sort-order="onChangeSortOrder"
                    @show-filter="filterIsShowed = true"
                    @reset-all="resetAll"
                    :with-pagination="parseInt(catalogLastPage) > 1"
                    with-filter
                    :sort-options="sortOptions"
                    v-model="catalogPage"
                    :page-count="catalogLastPage"
                    :single-button-pagination="parseInt(catalogLastPage) > parseInt(catalogPage)"
                    :sort-order="sortOrder"
                    :filter-disabled="isFilterDisabled"
                    :sort-type="sortType"
                    class="families-detail__catalog"
                    :items="catalogItems">

                    <template #item="{ item }" >

                        <BlockOffer
                            :brand-name="get(item, 'brand.name')"
                            :name="get(item, 'name')"
                            :url="get(item, 'htmlUrl')"
                            :picture="get(item, 'picture.url')"
                            :produced-from="get(item, 'produced.from')"
                            :gender-code="get(item, 'gender.code')"
                            :rating="get(item, 'ratings.value')"
                            with-rating
                            :comments-count="get(item, 'comments.total')"
                            :caption="get(item, 'concentration.name', 0)"/>

                    </template>
                </CatalogList>
            </PageBlock>

            <PageBlock v-if="showRelatedNews" :title="$t('read_also')">
                <ArticlesList
                    :articles="relatedNews"
                    :date-order="false" />
            </PageBlock>
            <PageBlock v-if="showRelatedArticles" :title="$t('best_articles')">
                <div class="families-detail__page-block">
                    <ArticleRowItem
                        :key="index + article.code"
                        v-for="(article, index) in relatedArticles"
                        :data="article"/>
                </div>
            </PageBlock>
            <PageBlock v-if="showRelatedPages" :title="$t('chained_pages')">
                <div class="families-detail__page-block">
                    <LinkedPagesList :items="relatedPages"/>
                </div>
            </PageBlock>
        </div>

        <transition name="fade">
            <ModalFilter
                v-show="filterIsShowed"
                :disable-modal-parent-scroll="filterIsShowed"
                @close-sidebar="filterIsShowed = false"
                :isOpened="filterIsShowed"
                :filtersCount="filtersCount"
                :params="filterParams">
                <template #filter-body>
                    <PerfumesFilter 
                        ref="filter"
                        :fields="filterFields" 
                        :settedValues="filterParams" 
                        :additionalValues="{q: searchQuery}"
                        :isModal="true"
                        @change="filtersCount = $event.count"
                        @submit="onFilterSubmit"
                        @reset="onFilterReset"
                        class="cat-filter_modal" />
                </template>
            </ModalFilter>
        </transition>

    </div>
</template>

<script>
import get from "lodash/get";
import assignIn from 'lodash/assignIn'

import { mapGetters } from "vuex";
import buttonActionsMixin from '@/mixins/catalog/buttonActions';
import SubscriptionsMixin from '@/mixins/catalog/subscriptions.mixins'
import { getCatalogQuery, getApiQueryParams, CatalogListMixin } from '@/mixins/catalog/catalogList.mixin';

import Group from '@/models/catalog/Group';
import Perfume from '@/models/catalog/perfume';
import Field from '@/models/services/field'
import Filter from '@/models/services/filter'

import PageBlock from '@/components/layout/AppPageBlock';
import Breadcrumb from '@/components/layout/nav/Breadcrumb';
import SectionCard from '@/components/layout/AppSectionCard';
import ButtonSquare from '@/components/ui/buttons/ButtonSquare';
import CatalogList from '@/components/catalog/CatalogList';
import BlockOffer from '@/components/catalog/BlockOffer';
import ArticlesList from '@/components/layout/blocks/ArticlesList/ArticlesList';
import ArticleRowItem from '@/components/layout/blocks/ArticlesList/ArticleRowItem';
import LinkedPagesList from '@/components/layout/blocks/LinkedPagesList';
import BlockPricePanel from '@/components/catalog/BlockPricePanel';
import AppContent from '@/components/layout/AppContent'
import AromaBox from '@/components/catalog/aromabox';

import PerfumesFilter from '@/components/catalog/filters/PerfumesFilter';
import ModalFilter from '@/components/catalog/filters/parts/ModalFilter';

export default {
    name: 'FamiliesDetail',
    components: {
        LinkedPagesList,
        ArticleRowItem,
        ArticlesList,
        BlockOffer,
        CatalogList,
        ButtonSquare,
        SectionCard,
        Breadcrumb,
        PageBlock,
        BlockPricePanel,
        PerfumesFilter,
        ModalFilter,
        AppContent,
        AromaBox
    },
    mixins: [buttonActionsMixin, CatalogListMixin, SubscriptionsMixin],
    fetchOnServer: false,
    fetch() {
        if (this.$auth.loggedIn) {
            if (this.$auth.user.id) {
                const userId = this.$auth.user.id
                const family = new Group({
                    code: this.$route.params.code
                })
                const authRequests = [
                    family.userLikes().where('created_by', userId).get(),
                    ...this.getSubscriptionsRequests()
                ]

                return Promise.all(authRequests).then(results => {
                    this.liked = !!get(results, '[0][0].items[0]')
                    this.parseSubscriptions([ results[1], results[2] ])

                    this.$bus.$emit('fetch-complete')
                })
            }
        }
    },
    asyncData({app, query, params, error}) {
        const baseUrl = app.i18n.__baseUrl;
        const catalogHref = app.router.resolve({
            name: 'Families'
        }).href;


        const catalogItemsPerPage = 40;
        const familyModel = new Group({
            code: params.code
        });

        const perfume = new Perfume()
        const filter = new Filter()
        const field = new Field()
        const filterFields = new Field().custom('services', filter, perfume, field)

        // массив фильтров из query
        const catalogParams = getCatalogQuery(query, true);
        const perfumesParams = {
            ...getApiQueryParams(query, {}, 'q'),
            per_page: catalogItemsPerPage,
            page: 1
        };
        const filterParams = catalogParams.filters || {};

        // Формируем параметры
        const familyParams = assignIn({}, perfumesParams, filterParams, {
            group: params.code
        });

        const requests = [
            (new Group).find(params.code),
            // Используем фильтры для запроса к ароматам
            perfume.params(familyParams).get(),
            familyModel.relatedNews().get(),
            familyModel.relatedArticles().get(),
            familyModel.relatedPages().get(),
            filterFields.get(),
            app.$api.get(`/groups/${params.code}/aroma-boxes`)
        ];

        return Promise.all(requests).then(results => {
            const catalogPage = perfumesParams.page;
            const searchQuery = perfumesParams.q;
            const sortType = perfumesParams.sort || 'popularity';
            const sortOrder = perfumesParams.order || 'desc';

            const family = get(results, '[0]');
            const catalogItems = get(results, '[1][0][items]');
            const perfumesCount = get(results, '[1][0].total');
            const totalItems = get(results, '[0].perfumes.total', 0);
            const catalogLastPage = get(results, '[1][0].lastPage', 1);
            const relatedNews = results[2];
            const relatedArticles = results[3];
            const relatedPages = results[4];
            const filterFields = get(results, '[5][0]');
            if (filterFields.groups) {
                delete filterFields.groups;
            }

            const familyAromabox = get(results, '[6].data', {})

            const breadcrumbs = [
                {
                    path: baseUrl,
                    name: app.i18n.t('breadcrumbs.perfumes'),
                },
                {
                    path: baseUrl + catalogHref,
                    name: app.i18n.t('breadcrumbs.families'),
                },
                {
                    path: baseUrl + catalogHref + get(family, 'code', ''),
                    name: get(family, 'name', ''),
                }
            ];

            if (process.server) {
                app.store.dispatch('rest/headers/filterLastModified', {
                    url: [
                        `/groups/${family.code}`,
                        `/groups/${family.code}/perfumes`
                    ]
                });
            }

            return {
                breadcrumbs,
                family,
                perfumesCount,
                catalogItems,
                relatedNews,
                relatedArticles,
                relatedPages,
                // catalogPage,
                searchQuery,
                sortType,
                sortOrder,
                filterParams: {...filterParams, group: params.code},
                filters: {...filterParams, group: params.code},
                staticFilters: ['group'],
                itemsTotal: perfumesCount,
                totalItems,
                filterFields,
                catalogPage,
                catalogLastPage,
                catalogItemsPerPage,
                familyAromabox
            }
        }).catch((e) => {
            error({statusCode: e.response.status, message: e.response.data});
        });
    },
    data() {
        return {
            queryPending: false,
            perfumesCount: 0,
            liked: false,
            loaded: false,
            breadcrumbs: [],
            family: {},
            filters: {},
            filterFields: {},
            filterParams: {},
            filtersCount: 0,
            q: null,
            nameProp: 'q',
            catalogItems: [],
            searchQuery: null,
            catalogPage: 1,
            catalogLastPage: 5,
            perPage: 100,
            totalItems: 0,
            catalogQueryObject: null,
            sortType: 'popularity',
            sortOrder: 'desc',
            sortOptions: {
                popularity: {
                    name: this.$t('popular')
                },
                rating: {
                    name: this.$t('rating')
                },
                year: {
                    name: this.$t('date')
                },
                name: {
                    name: this.$t('alphabet')
                },
            },
            relatedNews: [],
            relatedArticles: [],
            relatedPages: [],
            filterIsShowed: false,
            catalogItemsPerPage: null,
            singleButtonPagination: true,
            isLikeProcess: false,
            familyAromabox: {}
        }
    },
    computed: {
        entityModel() {
            return new Group({
                group_code: this.entityCode
            })
        },
        entityCode() {
            return this.family.code
        },
        entityTag() {
            return this.family.entityTag
        },
        showSingleButtonPagination() {
            return parseInt(this.catalogLastPage) > parseInt(this.catalogPage)
        },
        getName() {
            return get(this.family, 'name', '') + ' ' + this.$t('perfumes_l')
        },
        ...mapGetters(['getNoImage', 'isDeviceDesktop']),
        perfumesTotal() {
            return get(this.family, 'perfumes.total')
        },
        showRelatedArticles() {
            return !this.isDeviceDesktop && this.relatedArticles && this.relatedArticles.length
        },
        showRelatedNews() {
            return !this.isDeviceDesktop && this.relatedNews && this.relatedNews.length
        },
        showRelatedPages() {
            return !this.isDeviceDesktop && this.relatedPages && this.relatedPages.length
        },
        likesCountTooltipPhrase() {
            const likes = this.get(this.family, 'likes.total', 0);

            if (likes < 1) {
                return this.$t('tooltip_like');
            }

            return this.$t('tooltip_like') + this.$t('tooltip_like_users', {
                total: this.$options.filters.numberDeclension(likes, this.$t('declensions.for_users'))
            });
        },
        compositeTitle(){
            return `<span class="page-block__title-sup">${this.$t('caption')}</span> ${get(this.family, 'name', '')}`
        }
    },
    watch: {
        itemsTotal(value) {
            this.perfumesCount = value
        },
    },
    mounted() {
        this.loaded = true;

        const familyModel = new Group({
            code: this.$route.params.code
        });
        this.filtersCount = this.$refs.filter.filtersCount;
        this.catalogQueryObject = familyModel.groupPerfumes()
    },
    methods: {
        get,
        handleLike() {
            if(!this.isLikeProcess){
                this.isLikeProcess = true;
                this.$authEmit('like', !this.liked);
            }
        },
        handleSubscribe() {
            this.$authEmit('subscribe', {
                type: 'group',
                entity: {
                    name: this.family.name,
                    code: this.entityCode,
                    picture: get(this.family, 'picture.url')
                },
                entityTag: this.entityTag
            });
        },
    },
    head() {
        return {
            title: get(this.family, 'meta.title'),
            meta: this.$options.filters.metaApiExtract(this.family),
            link: [
                {
                    hid: 'i18n-can',
                    rel: 'canonical',
                    href: get(this.family, 'meta.canonical')
                }
            ]
        }
    },
    globalBus: {
        async 'like'(value) {
            const notices = {
                'onLiked': this.$t("is_liked"),
                'onUnliked': this.$t("is_unliked"),
                'onLikeAlready': this.$t("liked_already"),
            };
            this.liked = await this.onActionLike(value, new Group({code: this.$route.params.code}), notices)
            this.isLikeProcess = false;
        },
        'auth-complete'() {
            this.$fetch()
        }
    }
};
</script>

<style lang="less">
.families-detail {
    &__page {
        @{desktop} & {
            margin-bottom: rem(100);
        }
    }

    &__picture {
        --size: rem(80);

        display: block;

        border-radius: 50%;

        margin-bottom: rem(12);

        height: var(--size);
        width: var(--size);

        &-wrapper {
            .page-padding();
            @{desktop} & {
                border: 1px solid @color-gray-white;
                border-radius: rem(5);

                margin-bottom: rem(40);
                padding: rem(40);

                height: rem(343);
            }
        }
        @{desktop} & {
            --size: rem(263);
            .center-image(263);
            margin-bottom: 0;

            max-height: rem(263);
            max-width: rem(263);
        }
    }

    &__caption {
        color: @color-gray-light;
        font-size: rem(15);

        margin-bottom: rem(4);
    }

    &__right-block {
        @{desktop} & {
            .page-block__header {
                padding-top: 0;
                padding-right: rem(195);
                padding-bottom: rem(12);
            }

            // .page-block__content {
            //     padding-top: rem(26);
            // }
        }
    }

    &__buttons {
        display: flex;
        flex-flow: row nowrap;

        position: absolute;
        top: 0;
        right: 0;

        .rightbar__button {
            position: relative;

            &:not(:first-of-type) {
                margin-left: rem(12);
            }
        }
    }

    &__rightbar {
        .rightbar {
            &__button {
                margin-bottom: rem(12);
            }
        }
    }

    &__catalog {
        
        @{desktop} & {
            padding-top: rem(26);
        }

        --grid-item-height: rem(302);

        &.catalog-list{
            --grid-item-height: rem(302);
        }
    }
}
</style>
